import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const HomeUpcomingFixture = ({ speed = 20 }) => {
  const sliderRef = useRef(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const slider = sliderRef.current;
    let scrollAmount = 0;

    function scrollHeadlines() {
      if (slider) {
        scrollAmount += 1;
        if (scrollAmount >= slider.scrollWidth / 2) {
          scrollAmount = 0;
        }
        slider.style.transform = `translateX(-${scrollAmount}px)`;
      }
    }

    const interval = setInterval(scrollHeadlines, speed);
    return () => clearInterval(interval);
  }, [speed]);

  const getImageClass = (sportId) => {
    if (sportId === "1") {
       return 'd-icon icon-1';
    }else if (sportId === "4") {
       return 'd-icon icon-4';
    }else if (sportId === "2") {
       return 'd-icon icon-2';
    }else if (sportId === "400") {
       return 'd-icon icon-66';
    }else if (sportId === "500") {
      return 'd-icon icon-40';
    }else if (sportId === "4339") {
      return 'd-icon icon-65';
    }else if (sportId === "7") {
      return 'd-icon icon-10';
    }else{
       return 'd-icon icon-4';
    }
 }

  const [upcomingFixtureList, setUpcomingFixtureList] = useState([]);

   useEffect(() => {
     getAPI();
   }, []);

   const getAPI = () => {
     const myHeaders = new Headers();
     myHeaders.append("Content-Type", "application/json");

     const requestOptions = {
       method: "GET",
       headers: myHeaders,
       redirect: "follow",
     };

     fetch(`${process.env.REACT_APP_BASE_URL}/upcomingEvent`, requestOptions)
       .then(async (response) => {
         let paresData = await response.json();
         setUpcomingFixtureList(paresData.upcomingEventdata)
       })
       .catch((error) => {
         console.log(error);
       });
   };

 const formatDatefromAPI = (isoDate) => {
  const date = new Date(isoDate);

  // Get date components
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getUTCFullYear();

  // Get time components in UTC+05:30 (Indian Standard Time)
  const options = { timeZone: "Asia/Kolkata", hour12: false };
  const timeString = date.toLocaleTimeString("en-GB", options); // 24-hour format HH:mm:ss

  // Get the UTC offset (+05:30)
  const offset = date.getTimezoneOffset(); // Returns offset in minutes
  const offsetHours = String(Math.abs(offset) / 60).padStart(2, "0");
  const offsetMinutes = String(Math.abs(offset) % 60).padStart(2, "0");
  const offsetSign = offset > 0 ? "-" : "+";

  return `${day}/${month}/${year} ${timeString} (UTC${offsetSign}${offsetHours}:${offsetMinutes})`;
};


  return (
    <div className="headline-slider">
      <div className="headline-title">
      {t('UpcomingFixure')}
      </div>
      <div className="headlines-list">
      <div className="headlines" ref={sliderRef}>
      {upcomingFixtureList && upcomingFixtureList?.length > 0 ?
        upcomingFixtureList?.map((item, index) => (
         <div className="fixure-box" key={index} id={index}>
         <div className="title">
           <i className={`${getImageClass(item.sportId)}`}></i> {item.eventName}
         </div>
         <div className="time">{formatDatefromAPI(item.openDate)}</div>
       </div>
        )):<span>No Upcoming Events.</span>}
      </div>
      </div>
    </div>
  );
};

export default HomeUpcomingFixture;
